import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import LinkButton from '../ui/LinkButton'
import styles from './BordeDetalle.module.css'

const BordeDetalle = forwardRef(
  ({ className = '', vieneDeTiendas, titulo, categoriaLinks, onCerrarClick, children }, ref) => {
    return (
      <fieldset
        ref={ref}
        className={`${styles.contenedor} ${className} ${vieneDeTiendas ? styles.fieldsetBordeDetalle : 'fieldset'}`}
      >
        <div className={styles.cabecera}>
          <legend>
            {categoriaLinks?.length > 0 ? (
              <span className={styles.categoriaPath}>
                <span className={styles.categoriaLabel}>
                  <i className="fa fa-tag" aria-hidden="true" />
                  Categoría
                </span>
                {categoriaLinks.map((cat, index) => {
                  const esUltima = index === categoriaLinks.length - 1
                  return (
                    <span key={cat.id} className={styles.categoriaItem}>
                      <button
                        type="button"
                        className={`${styles.categoriaLink} ${esUltima ? styles.categoriaActual : ''}`}
                        onClick={() => cat.onClick()}
                        aria-current={esUltima ? 'page' : undefined}
                      >
                        {cat.name}
                      </button>
                      {!esUltima && (
                        <i
                          className={`fa fa-angle-right ${styles.categoriaSeparador}`}
                          aria-hidden="true"
                        />
                      )}
                    </span>
                  )
                })}
              </span>
            ) : (
              titulo
            )}
          </legend>
          <LinkButton
            onClick={onCerrarClick}
            className={styles.cerrar}
            aria-label="Cerrar"
            title="Cerrar"
          >
            <i className="fa fa-times" aria-hidden="true" />
          </LinkButton>
        </div>
        {children}
      </fieldset>
    )
  }
)

BordeDetalle.displayName = 'BordeDetalle'
BordeDetalle.propTypes = {
  className: PropTypes.string,
  vieneDeTiendas: PropTypes.bool,
  titulo: PropTypes.string.isRequired,
  categoriaLinks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired
    })
  ),
  onCerrarClick: PropTypes.func.isRequired,
  children: PropTypes.node
}

export default BordeDetalle
